import IState from '@/interfaces/IState';
import ITrafficSource from '@/interfaces/ITrafficSource';

export default (state: IState) => (): ITrafficSource[] => {
  return Object.values(state.trafficSources);
};
